<template>
  <div>
    <b-card>
      <b-card-header>
        <h2>
          <feather-icon icon="LayersIcon" />
          {{ $t('AppTI.filters.provider') }}
        </h2>
      </b-card-header>
      <b-card-body>
        <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
          <b-form @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">
            <b-row>
              <b-col cols="12" md="6">
                <validation-provider #default="{errors}" :name="$t('AppTI.columns.name')" rules="required">
                  <b-form-group>
                    <h4>{{ $t('AppTI.columns.name') }}</h4>
                    <b-form-input type="text" placeholder="Nombre de proveedor" v-model="proveedorData.nombre" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                <validation-provider #default="{errors}" :name="$t('AppTI.provider.alias')" rules="required">
                  <b-form-group>
                    <h4>{{ $t('AppTI.provider.alias') }}</h4>
                    <b-form-input type="text" placeholder="Alias del proveedor"  v-model="proveedorData.alias"/>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                <validation-provider #default="{errors}" :name="$t('AppTI.provider.rfc')" rules="required|max:13|min:12">
                  <b-form-group>
                    <h4>{{ $t('AppTI.provider.rfc') }}</h4>
                    <b-form-input
                      v-model="proveedorData.rfc"
                      type="text"
                      placeholder="RFC del proveedor"
                      onkeyup="this.value = this.value.toUpperCase();"
                    />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                <validation-provider #default="{errors}" :name="$t('AppTI.provider.address')" rules="required">
                  <b-form-group>
                    <h4>{{ $t('AppTI.provider.address') }}</h4>
                    <b-form-input type="text" placeholder="Direccion del proveedor"  v-model="proveedorData.domicilio"/>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                <validation-provider #default="{errors}" :name="$t('AppTI.columns.email')" rules="required|email">
                  <b-form-group>
                    <h4>{{ $t('AppTI.columns.email') }}</h4>
                    <b-form-input type="text" placeholder="Email del proveedor"  v-model="proveedorData.correo"/>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row class="float-right mt-2 mb-2">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit">
                <b-spinner v-if="editingProvider" small class="mr-1" />
                {{ $t('Lists.Edit') }}
              </b-button>
            </b-row>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
  BSpinner,
  BForm,
  BFormInput,
  BFormGroup,
  BFormInvalidFeedback,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  required,
  max,
  min,
} from '@validations'
// import i18n from '@/libs/i18n'
import tiService from '@/services/informationTecnology.service'
import formValidation from '@core/comp-functions/forms/form-validation'
import { ref } from '@vue/composition-api'
import router from '@/router'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BSpinner,
    BForm,
    BFormInput,
    BFormGroup,
    BFormInvalidFeedback,

    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      required,
      max,
      min,
    }
  },
  setup() {
    const editingProvider = ref(false)
    const proveedorData = ref({
      proveedorTiId: null,
      nombre: '',
      alias: '',
      rfc: '',
      domicilio: null,
      correo: '',
    })
    const blankProviderData = {
      proveedorTiId: null,
      nombre: '',
      alias: '',
      rfc: '',
      domicilio: null,
      correo: '',
    }
    const resetProviderData = () => {
      proveedorData.value = JSON.parse(JSON.stringify(blankProviderData))
    }

    const {
      refFormObserver,
      resetForm,
    } = formValidation(resetProviderData)

    const {
      fetchProvider,
      updateProvider,
    } = tiService()

    fetchProvider(router.currentRoute.params.proveedorTiId, data => {
      proveedorData.value = data
    })

    const onSubmit = () => {
      editingProvider.value = true
      updateProvider(proveedorData.value)
        .then(() => {
          editingProvider.value = false
        })
    }
    return {
      refFormObserver,
      resetForm,
      proveedorData,
      editingProvider,
      onSubmit,
    }
  },
}
</script>
